import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

type SupportDestination = "about" | "terms" | "privacy" | void;
const SUPPORT_PATHS = {
  about: "/(nav)/support/about",
  privacy: "/(nav)/support/privacy",
  terms: "/(nav)/support/terms",
} as const;

function useNavigator() {
  return useCallback(
    (destination: SupportDestination) => ({
      href: {
        pathname: destination === undefined ? "/(nav)/support" : SUPPORT_PATHS[destination],
      },
      queries: [],
    }),
    [],
  );
}

export const useSupportSettingsPageNavigator = createPageNavigator<SupportDestination>({
  useNavigator,
});
